<template>
  <Swiper
    :modules="modules"
    :slides-per-view="'auto'"
    :space-between="24"
    :grabCursor="true"
    :speed="600"
    :class="$style.swiper"
    :breakpoints="{
      460: {
        slidesPerView: 1.8
      },
      768: {
        slidesPerView: 2.2
      },
      1024: {
        slidesPerView: 3
      }
    }"
  >
    <SwiperSlide v-for="(image, index) in data" :key="index">
      <Image
        class="aspect-square w-full rounded-3xl object-cover"
        :src="image.responsiveImage ? image.responsiveImage?.src : image.url"
        :srcset="image.responsiveImage ? image.responsiveImage?.webpSrcSet : undefined"
        :width="image.responsiveImage ? image.responsiveImage?.width : image.width"
        :height="image.responsiveImage ? image.responsiveImage?.height : image.height"
        sizes="(min-width: 1400px) 405px, (min-width: 780px) calc(27.67vw + 23px), (min-width: 480px) 406px, 86.25vw"
        :alt="image?.alt!"
      />
      <div class="text-gray-70 mt-6 text-sm">
        {{ image.responsiveImage?.title }}
      </div>
    </SwiperSlide>
    <SwiperNav class="absolute bottom-0 right-0 top-auto z-20" is-loop />
  </Swiper>
</template>

<script setup lang="ts">
import { Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { FileField } from '~/types/generated'

import 'swiper/css'

defineProps({
  data: {
    type: Array as PropType<FileField[]>,
    default: () => []
  }
})

const modules = [Parallax, A11y]
</script>

<style lang="postcss" module>
.swiper {
  @apply relative mx-auto h-auto w-full pb-20;
}
</style>
